"use client";

import { useEffect, useRef } from "react";

export function AdImpression({
  id,
  campaignId,
  creativeId,
  placement,
}: {
  id: string;
  campaignId?: string | null;
  creativeId?: string | null;
  placement?: string | null;
}) {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    const isInternalCampaign =
      campaignId && !campaignId.startsWith("legacy:") && !campaignId.startsWith("ext:");
    fetch(isInternalCampaign ? "/api/ads/viewable" : "/api/ads/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(
        isInternalCampaign
          ? { campaignId, creativeId, placement, event: "impression" }
          : { id, event: "impression", placement },
      ),
      keepalive: true,
    }).catch(() => null);
  }, [id, campaignId, creativeId, placement]);
  return null;
}
